/* ============================================================
   BloomUp — remove a cart line when minus is pressed at quantity 1

   The stepper in bloomup-cart.js clamps at the line's minimum, so pressing
   minus on a single item did nothing and the trash icon was the only way to
   remove it. This runs BEFORE that handler (capture phase, registered
   earlier by load order) and, only in the qty-1 case, removes the line
   instead. Every other press falls through to the normal stepper.
   ============================================================ */
(function () {
  "use strict";

  var busy = false;

  document.addEventListener("click", function (e) {
    if (busy) return;
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest("#CartDrawer .hdt-quantity-cart-item button");
    if (!btn) return;

    var isMinus = btn.classList.contains("is--minus") || btn.name === "minus";
    if (!isMinus) return;

    var wrap = btn.closest(".hdt-quantity-cart-item");
    var input = wrap ? wrap.querySelector(".hdt-quantity-input") : null;
    if (!input) return;

    var cur = parseInt(input.value, 10);
    if (isNaN(cur) || cur > 1) return;   /* normal decrement — let it through */

    var line = parseInt(input.getAttribute("data-index"), 10);
    if (!line) return;

    /* this press means "remove" — stop the stepper from also handling it */
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    busy = true;

    var row = btn.closest(".hdt-mini-cart__item");
    if (row) row.style.opacity = "0.45";

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("remove failed");
        if (window.BUCart && window.BUCart.rerender) {
          window.BUCart.rerender(function () { busy = false; });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        busy = false;
        if (row) row.style.opacity = "";
      });
  }, true);
})();